import RenderAtlasScreen from "./atlasScreenRenderer";
import RenderLoadingScreen from "./loadingScreenRenderer";

const ScreenRenderers = [
    RenderAtlasScreen,
    RenderLoadingScreen
];

export default ScreenRenderers;